import type { ILangArr } from './lang'
import { langArr, langMap } from './lang'
import i18n, { getCurrentLang, importLocLang, messages } from '@/locales'
import { useStorage } from '@/hooks/system/useStorage'
import { EGlobalConfig } from '@/enums/cacheEnum'

// i18n
export const useI18n = i18n.global
/** 内置方法 t, setLocaleMessage */
export const { t: T, locale, setLocaleMessage } = useI18n

export function t(key: string) {
  return computed(() => T(key))
}

/** 所有语言类型 集合 */
export const LANG_ALL = langArr

/** 所有语言类型 map */
export const LANG_MAP = langMap

/** 获取 lang 目录下已配置的语言类型 集合 */
export const useLangList = (): ILangArr[] => langArr.map((e) => {
  return {
    value: e.value,
    name: langMap[e.value],
    icon: `image/flag/${e.value}`,
  }
})
//   messages.map((e) => {
//   return {
//     value: e.key,
//     name: langMap[e.key],
//     icon: `image/flag/${e.key}`,
//   }
// })

/** 获取当前语言 function */
export const useCurrentLang = getCurrentLang

/** 当前语言 */
export const currentLang = computed({
  get() {
    return locale.value
  },
  set(value: string) {
    // 避免重复设置导致死循环
    if (locale.value !== value) {
      useChangeLang(value)
    }
  },
})

/** 切换语言 */
export async function useChangeLang(value: string) {
  useStorage.ls.set(EGlobalConfig.language, value)
  await importLocLang(value)

  // document.documentElement.lang = messages.find(e => e.key === value)?.name
}

export const isChinese = computed(() => ['CMN', 'ZHO'].includes(currentLang.value))
